import {
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_BASE_URL } from '@app/app.constants';
import { getHttpMocks } from '@app/utils/http-mocks';
import { MockHelpers } from '@app/utils/http-mocks/helpers';
import { loggerFor } from '@app/utils/logger';
import { isObservable, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MockHttpInterceptorService implements HttpInterceptor {
  private log = loggerFor('MockHttpInterceptorService');

  private urlMapping = getHttpMocks();

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(MockHelpers.isMockedRequest)) {
      return next.handle(req);
    } else {
      const maybeMapping = this.findMapping(req.method, req.url);

      if (maybeMapping != null) {
        return new Observable<HttpEvent<any>>((subscriber) => {
          subscriber.next({
            type: HttpEventType.Sent,
          });

          setTimeout(
            () => {
              try {
                const maybeUsername = MockHelpers.getUsername(req);
                const result = maybeMapping(req, maybeUsername);

                if (isObservable(result)) {
                  this.log.debug(`Waiting for mock to return value ${req.method} ${req.url}`);

                  result.subscribe({
                    error: (response: any) => {
                      this.log.error('Caught error response');

                      subscriber.error(response);
                      subscriber.complete();
                    },
                    next: (response: any) => {
                      this.log.debug(`Intercepted ${req.method} ${req.url} with result`, response);

                      if (response instanceof HttpResponse) {
                        subscriber.next(response);
                      } else {
                        subscriber.next(
                          new HttpResponse({
                            body: response,
                            status: 200,
                            statusText: 'Ok',
                          })
                        );
                      }

                      subscriber.complete();
                    },
                  });
                } else {
                  this.log.debug(`Intercepted ${req.method} ${req.url} with result`, result);

                  subscriber.next(
                    new HttpResponse({
                      body: result,
                      status: 200,
                      statusText: 'Ok',
                    })
                  );
                  subscriber.complete();
                }
              } catch (e) {
                this.log.debug(`Intercepted ${req.method} ${req.url} with error`, e);

                subscriber.error(e);
                subscriber.complete();
              }
            },
            Math.floor(Math.random() * 750 + 250)
          );
        });
      } else {
        return next.handle(req);
      }
    }
  }

  private findMapping(
    method: string,
    url: string
  ): (request: HttpRequest<any>, username?: string) => any | null {
    let mapping: any = null;
    const testUrl = url.replace(API_BASE_URL, '');
    const maybeMapping = this.urlMapping.find((mapping) => {
      let matches: boolean;

      if (typeof mapping.url === 'string') {
        matches = mapping.url === testUrl;
      } else {
        matches = mapping.url.test(testUrl);
      }

      return matches;
    });

    if (maybeMapping != null) {
      mapping = maybeMapping[method.toLowerCase()] ?? null;
    }

    return mapping;
  }
}
